import React, { useEffect, useState } from "react";
import Carousel from "react-bootstrap/Carousel";
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";
import defaultBanner from "../../Assets/defaultBanner.png";

const TopSellingBrands = () => {
  const [groupedCarouselData, setGroupedCarouselData] = useState([]);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 992);
  const [currentIndex, setCurrentIndex] = useState(0);
  const getOfferMasterData = useSelector(
    (state) => state.offerMasterReducer?.getofferMaster
  );

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 992);
    };
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);
  useEffect(() => {
    if (Array.isArray(getOfferMasterData)) {
      const today = new Date();
      today.setHours(0, 0, 0, 0);

      const enabledData = getOfferMasterData.filter((item) => {
        if (!item.enabled || item.placement !== "Bottom") return false;
        const startDate = new Date(item.startDate);
        startDate.setHours(0, 0, 0, 0);
        const endDate = new Date(item.endDate);
        endDate.setHours(0, 0, 0, 0);
        return today >= startDate && today <= endDate;
      });
      const sortedData = [...enabledData].sort(
        (a, b) => parseInt(a.displayOrder) - parseInt(b.displayOrder)
      );
      const groupedData = [];
      const length = sortedData.length;

      for (let i = 0; i < length; i++) {
        const currentItem = sortedData[i];
        const nextItem = sortedData[(i + 1) % length];
        groupedData.push([currentItem, nextItem]);
      }
      setGroupedCarouselData(groupedData);
    }
  }, [getOfferMasterData]);
  const handleDotClick = (index) => {
    setCurrentIndex(index);
  };
  return (
    <>
      {getOfferMasterData?.length ? (
        <div className="mainDiv pb-3">
          {/* <h5 className="top_selling_Brand_heading container">
            Top Selling Brands
          </h5> */}
          <Carousel
            interval={6000}
            controls={false}
            activeIndex={currentIndex}
            onSelect={(selectedIndex) => setCurrentIndex(selectedIndex)}
          >
            {groupedCarouselData.map((pair, index) => (
              <Carousel.Item key={index}>
                <section className="py-0 pb-0 earn mb-3">
                  <div className="container">
                    <div className="row m-xl-n3 m-md-n2 m-n1 mt-2 ">
                      {pair
                        ?.sort((a, b) => a.displayOrder - b.displayOrder)
                        ?.map((offerMasterData, imgIndex) =>
                          (isMobile && imgIndex === 0) || !isMobile ? (
                            <div className="col-lg-6 col-12" key={imgIndex}>
                              <div className="position-relative">
                                <Link to={offerMasterData?.link}>
                                  <img
                                    src={`${process.env.REACT_APP_CLIENT_URL}${offerMasterData.image}`}
                                    alt={
                                      offerMasterData.alt ||
                                      `Image ${imgIndex + 1}`
                                    }
                                    onError={(e) => {
                                      e.target.onerror = null;
                                      e.target.src = defaultBanner;
                                    }}
                                    className="d-block w-100 topSelling_H"
                                  />
                                </Link>

                                {/* Optional: Add text overlay */}
                                {/* {offerMasterData.title && ( */}
                                <div className="position-absolute top-50 start-50 translate-middle text-white">
                                  {/* {offerMasterData.title} */}
                                </div>
                                {/* )} */}
                              </div>
                            </div>
                          ) : null
                        )}
                    </div>
                  </div>
                </section>
              </Carousel.Item>
            ))}
          </Carousel>
          {((isMobile && groupedCarouselData?.length > 1) ||
            (!isMobile && groupedCarouselData?.length > 2)) && (
            <div className="dots-container">
              {groupedCarouselData.map((_, index) => (
                <div
                  key={index}
                  className={`dot1 ${index === currentIndex ? "active" : ""}`}
                  onClick={() => handleDotClick(index)}
                />
              ))}
            </div>
          )}
        </div>
      ) : (
        ""
      )}
    </>
  );
};

export default TopSellingBrands;
